<template>
    <div class="flex flex-col gap-2">
        <UCheckbox
            v-for="o in options"
            :key="o.value"
            :model-value="values.includes(o.value)"
            @update:model-value="toggle(o, $event)"
        >
            <template #label>
                <span class="flex items-center gap-1.5">
                    <span :class="[o.dot, 'inline-block size-1.5 flex-shrink-0 rounded-full']" aria-hidden="true" />
                    {{ o.name }}
                </span>
            </template>
        </UCheckbox>
    </div>
</template>

<script setup lang="ts">
import { CallSource } from '~/types/call'
import type { Filter } from '~/types/filter'

const emit = defineEmits<{ 'update:filter': [Filter] }>()
const props = defineProps<{ filter: Filter }>()

const options = [
    { name: 'App', value: CallSource.app, dot: 'bg-lime-500' },
    { name: 'External', value: CallSource.external, dot: 'bg-sky-500' },
]

const values = computed<string[]>(() => (Array.isArray(props.filter.value) ? props.filter.value : []))

function toggle(opt: { name: string; value: string }, on: boolean) {
    const next = on ? [...values.value, opt.value] : values.value.filter(v => v !== opt.value)
    const selected = options.filter(o => next.includes(o.value))
    emit('update:filter', { ...props.filter, value: next.length ? next : undefined, selected: selected.length ? selected : undefined })
}
</script>
